import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  variant?: 'default' | 'elevated' | 'bordered' | 'interactive' | 'glass' | 'section' | 'compact';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  variant = 'default',
  padding = 'md',
  className = '',
  onClick,
}) => {
  const baseClasses = 'bg-white/95 rounded-xl transition-all duration-200';

  const variantClasses: Record<string, string> = {
    default: 'shadow border border-monday-border-light',
    elevated: 'shadow-md border border-monday-border-light hover:shadow-lg hover:-translate-y-0.5',
    bordered: 'border border-monday-border bg-white/80',
    interactive:
      'shadow border border-monday-border-light hover:shadow-lg hover:-translate-y-0.5 hover:border-primary-200 cursor-pointer group',
    glass: 'bg-white/80 backdrop-blur shadow border border-monday-border-light',
    section: 'shadow border border-monday-border-light overflow-hidden',
    compact: 'shadow-xs border border-monday-border-light',
  };

  const paddingClasses: Record<string, string> = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const Component = onClick ? 'button' : 'div';

  return (
    <Component
      className={`${baseClasses} ${variantClasses[variant]} ${paddingClasses[padding]} ${className}`}
      onClick={onClick}
      type={onClick ? 'button' : undefined}
    >
      {children}
    </Component>
  );
};

export default Card;
